import gql from 'graphql-tag'

export default gql`query ($id: Int!){
  annual_leave_record(id: $id){
    id
    start_date
    start_of_day
    end_date
    end_of_day
  }
}`